import { useQuery } from '@tanstack/react-query';
import { systemApi } from '@/api/system';
import { queryKeys } from '@/lib/queryKeys';

/** The dashboard's numbers: sites, jobs, what needs attention, open alerts. */
export function useOverview() {
  return useQuery({ queryKey: queryKeys.overview, queryFn: systemApi.overview, refetchInterval: 10000 });
}

/** Retention, backup storage, the panel's own backup. Changes with a deploy, not by the minute. */
export function useSystemSettings() {
  return useQuery({ queryKey: queryKeys.systemSettings, queryFn: systemApi.settings, staleTime: 300_000 });
}
